var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      staticStyle: { "max-width": "140px" },
      attrs: { href: _vm.storeUrl, target: "_blank" },
    },
    [
      _c("img", {
        attrs: {
          src: "/img/google_play_badge.svg",
          alt: "Android",
          title: "Android",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }